module.exports = __webpack_public_path__ + "static/media/Screenshot33.61455faa.jpg";